import { AsyncActionButton, FilteredCreditApplication, reportErrorToConsole, SinInput, SubmitHardHitDto, useSubmitHardHit } from '@applyonline/shared'
import { yupResolver } from '@hookform/resolvers/yup'
import { EFinancingProgram } from '@if/core/types'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { getLoanAmount } from '../../../../data/credit-application-selectors'
import {
  buildEditSinAndLoanAmountSchema,
  EditSinAndLoanAmount,
} from '../../../../types/Schemas/PrequalificationSchema'
interface Props {
  creditApp: FilteredCreditApplication
}

const CoappSinForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [submitCoappSin, isSubmitting] = useSubmitHardHit(EFinancingProgram.Personal)

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm<EditSinAndLoanAmount>({
    mode: 'onBlur',
    defaultValues: {
      needsApplicantSin: false,
      needsCoapplicantSin: true,
      requestedLoanAmount: getLoanAmount(creditApp),
      id: creditApp.id,
    },
    resolver: yupResolver(buildEditSinAndLoanAmountSchema(creditApp.prequalificationDecision.maxLoanAmount)),
  })

  const onSubmit = (data: EditSinAndLoanAmount) => {
    const dto: SubmitHardHitDto = {
      id: creditApp.id,
      coapplicantSin: data.coapplicantSin,
      requestedLoanAmount: data.requestedLoanAmount,
    }
    submitCoappSin(dto).catch(reportErrorToConsole)
  }
  return (
    <main className="general-message">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>{t('prequalification.coapplicantNewToCredit')}</h3>
        <SinInput error={errors.coapplicantSin} id="coapplicantSin" {...register('coapplicantSin')} mandatory={false} />
        <div className="btn-group justify-end">
          <AsyncActionButton type="submit" isPending={isSubmitting}>
            {t('common.submit')}
          </AsyncActionButton>
        </div>
      </form>
    </main>
  )
}

export default CoappSinForm
